import { Box, Heading, Text, useColorModeValue, HStack, Center } from '@chakra-ui/react'

export type DappProps = {
  link: string
  name: string
  description: string
}

export default function DappHighlight(props: DappProps) {
  const { link, name, description } = props

  return (
    <Box
      w={{ base: '40vw', md: '14vw' }}
      rounded={'md'}
      my={{base:3, md:6}}
      cursor={'pointer'}
      overflow={'hidden'}
      bg="white"
      border={'0px'}
      borderColor="black"
      boxShadow={'3px 3px 0 #000'}
      _hover={{ boxShadow: '3px 3px 6px #000' }}
      as={'a'}
      href={link}
    >
      <Box
        minH={'40px'}
        roundedTop={'sm'}
        p={'0.5rem'}
        bgColor={'second.500'}
        justifyContent={'center'}
      >
        <Center>
          <Heading color={'brand.50'} textAlign={'center'} fontSize={{base:"sm", md:'xl'}}>
            {name}
          </Heading>
        </Center>
      </Box>
      <Box p={2}>
        <Text color={'gray.500'} noOfLines={3} fontSize={{base:'xs',md:"sm"}} minHeight={'40px'}>
          {description}
        </Text>
      </Box>
    </Box>
  )
}
